import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
import bgImage from "../../assets/png/06062026-sml-loginpage.png";

function Login() {
  const navigate = useNavigate();
  const handleFormSubmit = () => {
    
  };

  return (
    <Grid
      container
      justifyContent="right"
      alignItems="center"
      width="100vw"
      
      sx={{
        height: "100vh",
        backgroundImage: `url(${bgImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center"
        
      }}
    >
      
      <LoginForm />
    </Grid>
  );
}

export default Login;